import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar/NavBar";
import "./Dashboard.css";
import ColumnChart from "../../Components/Charts/ColumnChart";
import BankDetailsComponent from "../../Components/DashboardComponents/BankDetailsComponent";
import SplineChart from "../../Components/Charts/SplineChart";
import MarketingCards from "../../Components/DashboardComponents/MarketingCards";
// import { useSession } from "../../authentications/SessionContext";
import QuickAccessComponent from "../../Components/DashboardComponents/QuickAccessComponent";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
// import CreateProduct from "../../Components/DashboardComponents/CreateProduct";
import { accountingApi } from "../../DataApi/accounting/accountingApi";
import ReactSelect from "react-select";
import { Helmet } from "react-helmet-async";
const splineMethodsOptionList = [
  { label: "This Year", value: "get_income_this_year" },
  { label: "This Month", value: "get_income_this_month" },
  { label: "Last Year", value: "get_income_last_year" },
  { label: "Last Month", value: "get_income_last_month" },
];
const invoicesListOption = [
  { label: "This Year", value: "get_total_invoice_current_year" },
  { label: "This Month", value: "get_total_invoice_current_month" },
  ,
];

const Dashboard = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [splineChartData, setSplineChartData] = useState();
  const [selectedMethod, setSelectedMethod] = useState(
    splineMethodsOptionList[0]
  );
  const [selectedInvoiceFilter, setSelectedInvoiceFilter] = useState(
    invoicesListOption[0]
  );
  const [cardsData, setCardsData] = useState({
    profitLoss: { monthly: 0, annual: 0 },
    totalIncome: { monthly: 0, annual: 0 },
    totalExpense: { monthly: 0, annual: 0 },
    unreconciledItems: { monthly: 0, annual: 0 },
  });
  const [bankCashBalanceList, setBankCashBalanceList] = useState([]);

  const [currencySymbol, setCurrencySymbol] = useState("$");
  const fetchData = async (payload) => {
    try {
      let response = await accountingApi(payload);
      response = JSON.parse(response);
      return response;
    } catch (error) {
      return {};
    }
  };
  const fetchSplineChartData = async () => {
    const splineChartResponse = await fetchData({
      method: selectedMethod?.value,
    });
    if (!splineChartResponse?.result) return;

    const {
      income,
      expense,
      profit,
      month = [],
      date = [],
    } = splineChartResponse?.result;
    const minValue = [...income, ...expense, ...profit].min();
    const maxValue = [...income, ...expense, ...profit].max() * 1.05;

    const dataList = [
      {
        name: "Income",
        data: income || [],
      },
      { name: "Expense", data: expense || [] },
      { name: "Profit", data: profit || [] },
    ];

    setSplineChartData({
      ...splineChartData,
      minValue,
      maxValue,
      dataList,
      categoriesList: month ? month?.map((item) => item?.trim()) : date,
    });
  };
  const getSum = (list = []) =>
    list.reduce((total, current) => {
      return total + (current || 0);
    }, 0);
  const getCreditDebitSum = (list = []) =>
    list.reduce(
      (total, current) => total + (current.credit || 0) - (current.debit || 0),
      0
    );
  const getUnreconciledItemsCount = (list = []) =>
    list.reduce((total, current) => total + (current.count || 0), 0);

  const fetchCardsData = async () => {
    try {
      Promise.all([
        // currency
        fetchData({ method: "get_currency", args: [] }),
        // profitloss
        fetchData({ method: "profit_income_this_month" }),
        fetchData({ method: "profit_income_this_year" }),
        // total income
        fetchData({ method: "month_income_this_month" }),
        fetchData({ method: "month_income_this_year", args: [] }),
        // total expense
        fetchData({ method: "month_expense_this_month" }),
        fetchData({ method: "month_expense_this_year" }),
        // unreconciled Items
        fetchData({ method: "unreconcile_items_this_month" }),
        fetchData({ method: "unreconcile_items_this_year" }),
      ]).then((response) => {
        const [
          currencyDetail,
          monthlyProfitLostt,
          annualProfitLoss,
          monthlyIncome,
          annualIncome,
          monthlyExpense,
          annualExpense,
          monthlyUnreconciled,
          annualUnreconciled,
        ] = response;

        setCurrencySymbol(currencyDetail?.result?.symbol);
        // profit and loss
        const profitLoss = {
          monthly: getSum(monthlyProfitLostt?.result),
          annual: getSum(annualProfitLoss?.result),
        };

        // total income
        const totalIncome = {
          monthly: getCreditDebitSum(monthlyIncome?.result),
          annual: getCreditDebitSum(annualIncome?.result),
        };

        // total expense
        const totalExpense = {
          monthly: getCreditDebitSum(monthlyExpense?.result),
          annual: getCreditDebitSum(annualExpense?.result),
        };

        // unreconciled Items
        const unreconciledItems = {
          monthly: getUnreconciledItemsCount(monthlyUnreconciled?.result),
          annual: getUnreconciledItemsCount(annualUnreconciled?.result),
        };

        // setState
        setCardsData({
          ...cardsData,
          profitLoss,
          totalIncome,
          totalExpense,
          unreconciledItems,
        });
      });
    } catch (error) {
      console.log("Error", error);
    }
  };
  const fetchBankAndCardsData = async () => {
    let response = await fetchData({ method: "bank_balance" });
    if (!response.result) return;
    const { banks, banking, bank_ids } = response?.result;
    const bankCashBalance = response?.result?.banks?.map((_, index) => ({
      bank: banks[index],
      amount: banking[index],
      id: bank_ids[index],
    }));
    setBankCashBalanceList([...bankCashBalance]);
  };

  const fetchTotalInvoicesData = async () => {
    let response = await fetchData({ method: selectedInvoiceFilter.value });
  };
  useEffect(() => {
    fetchSplineChartData();
  }, [selectedMethod]);
  useEffect(() => {
    fetchCardsData();
  }, []);
  useEffect(() => {
    fetchBankAndCardsData();
  }, []);
  useEffect(() => {
    fetchTotalInvoicesData();
  }, []);

  return (
    <div>
      <div className="section1">
        <QuickAccessComponent />
      </div>
      {/* // button of new product */}
      {/* <div className="newProductSection">
        <CreateProduct />
      </div> */}
      <div className="section2">
        <MarketingCards currencySymbol={currencySymbol} {...cardsData} />
      </div>
      <div className="section3">
        <div className="row mb-2">
          <div className="col d-flex align-items-center splineChart_title">
            {" "}
            {t["Income/Expense"]}
          </div>

          <div className="col d-flex justify-content-end">
            <ReactSelect
              width={200}
              options={splineMethodsOptionList}
              value={selectedMethod}
              onChange={setSelectedMethod}
            />
          </div>
        </div>{" "}
        <SplineChart {...splineChartData} />
        {/* <SplineChart /> */}
      </div>
      {/* <div className="section4">
        <div className="BarChart1">
          <div className="barchart1_details">
            <div className="title_and_date">
              <div className="customer_heading">{t["Customer Invoice"]}</div>
              <div className="date">2020-2021</div>
            </div>
            <div className="barchart_divs">
              <div className="totalinvoice_div">
                <div className="legend red-legend"></div>
                {t["Total Invoice"]}
              </div>
              <div className="totalpaid_div">
                <div className="legend green-legend"></div>
                {t["Total Paid"]}
              </div>
            </div>
          </div>
          <div className="column_chart">
            <ColumnChart />
          </div>
        </div>
        <div className="BarChart2">
          <div className="barchart2_details">
            <div className="title_and_date">
              <div className="supplier_heading">{t["Supplier Invoice"]}</div>
              <div className="date">2020-2021</div>
            </div>
            <div className="barchart_divs">
              <div className="totalinvoice_div">
                <div className="legend red-legend"></div>
                {t["Total Invoice"]}
              </div>
              <div className="totalpaid_div">
                <div className="legend green-legend"></div>
                {t["Total Paid"]}
              </div>
            </div>
          </div>
          <div className="column_chart">
            <ColumnChart />
          </div>
        </div>
      </div>
      <div className="section5">
        <BankDetailsComponent />
      </div> */}
    </div>
  );
};

export default Dashboard;
